import React, { useEffect, useState } from 'react';
import US_STATES from '../../data/usStates';
import { handleZipBlur } from '../../utils/zipAutoPopulate';
import ZipCityPopup from '../shared/ZipCityPopup';
import { getAccessToken } from '../../services/authApi';

const interviewMethodMapping = {
    "Face-to-Face Interview (includes Electronic Media w/ Video Component)": "FaceToFace",
    "Telephone Interview": "Telephone",
    "Fax or Mail": "Mail",
    "Email or Internet": "Internet",
};

const LoanOriginatorInformation = ({ fieldValues }) => {
    const [token, setToken] = useState(null);
    const [zipPopup, setZipPopup] = useState({ results: [], cityFieldId: '', stateFieldId: '' });
    const [localFieldValues, setLocalFieldValues] = useState({});
    const [state, setState] = useState({});

    const handleCheckboxChange = (fieldId, value) => {
        const group = document.querySelectorAll(`input[name="field-${fieldId}"]`);
        group.forEach(cb => {
            cb.checked = cb.value === value;
        });
        setState(prev => ({ ...prev, [fieldId]: value }));
    };

    useEffect(() => {
        setLocalFieldValues(fieldValues || {});
        setState(fieldValues || {});
    }, [fieldValues]);

    useEffect(() => {
        const savedState = fieldValues["321"];
        if (savedState) {
            const dropdown = document.getElementById("field-321");
            if (dropdown) dropdown.value = savedState;
        }
    }, [fieldValues]);


    const handleZipCodeBlur = async (zipId, cityId, stateId) => {
        let tokenToUse = token;

        if (!tokenToUse) {
            const authObject = await window.elli.script.getObject("auth");
            const authCode = await authObject.createAuthCode();
            tokenToUse = await getAccessToken(authCode);
            setToken(tokenToUse);
        }

        handleZipBlur({
            zipFieldId: zipId,
            cityFieldId: cityId,
            stateFieldId: stateId,
            token: tokenToUse,
            setPopupOptions: ({ results, cityFieldId, stateFieldId }) =>
                setZipPopup({ results, cityFieldId, stateFieldId })
        });
    };

    const textDateField = (label, id) => {
        const value = localFieldValues[id] === '//' ? '' : localFieldValues[id] || '';

        return (
            <div>
                <label className="form-label">{label}</label>
                <input
                    type="text"
                    className="form-input"
                    placeholder="mm/dd/yyyy"
                    id={`field-${id}`}
                    value={value}
                    maxLength={10}
                    onChange={(e) => handleChange(e, id)}
                    onBlur={(e) => handleBlur(e, id)}
                />
            </div>
        );
    };


    const formatDateInput = (value) => {
        // Remove non-digits
        const cleaned = value.replace(/\D/g, '');

        // Format MM/DD/YYYY
        let formatted = '';
        if (cleaned.length <= 2) {
            formatted = cleaned;
        } else if (cleaned.length <= 4) {
            formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
        } else {
            formatted = `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}/${cleaned.slice(4, 8)}`;
        }

        return formatted;
    };

    const validateDate = (dateStr) => {
        // Check format first
        if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) return false;

        const [month, day, year] = dateStr.split('/').map(Number);

        // Check valid month
        if (month < 1 || month > 12) return false;

        // Check valid day range for given month/year
        const testDate = new Date(year, month - 1, day);

        return (
            testDate.getFullYear() === year &&
            testDate.getMonth() === month - 1 &&
            testDate.getDate() === day
        );
    };


    const handleChange = (e, id) => {
        const input = e.target.value;
        const formattedInput = formatDateInput(input);
        setLocalFieldValues(prev => ({ ...prev, [id]: formattedInput }));
    };

    const handleBlur = (e, id) => {
        const value = e.target.value;
        if (value && !validateDate(value)) {
            alert('Invalid date format. Please enter as mm/dd/yyyy');
            setLocalFieldValues(prev => ({ ...prev, [id]: '' }));
            e.target.focus();
        }
    };

    return (
        <>
            <ZipCityPopup
                visible={zipPopup.results.length > 1}
                results={zipPopup.results}
                onSelect={(opt) => {
                    document.getElementById(zipPopup.cityFieldId).value = opt.city;
                    document.getElementById(zipPopup.stateFieldId).value = opt.abbrev;
                    setZipPopup({ results: [], cityFieldId: '', stateFieldId: '' });
                }}
                onClose={() => setZipPopup({ results: [], cityFieldId: '', stateFieldId: '' })}
            />

            <div className="border border-[var(--blue-2)] rounded bg-[#f9f9f9] mb-3">
                <div className="section-header">4. Loan Originator Information</div>

                <div className="p-4 space-y-4">
                    <div className="grid md:grid-cols-2 gap-4">
                        <div>
                            <label className="form-label">Loan Originator Organization Name</label>
                            <input
                                type="text"
                                className="form-input"
                                id="field-315"
                                defaultValue={fieldValues["315"] || ""}
                            />
                        </div>
                        <div>
                            <label className="form-label">Loan Originator Organization NMLSR ID#</label>
                            <input
                                type="text"
                                className="form-input"
                                id="field-3237"
                                defaultValue={fieldValues["3237"] || ""}
                            />
                        </div>
                    </div>

                    <div>
                        <label className="form-label">Address (street, city, state, ZIP)</label>
                        <div className="grid md:grid-cols-4 gap-2">
                            <input
                                type="text"
                                className="form-input"
                                placeholder="Street"
                                id="field-URLA.X188"
                                defaultValue={fieldValues["URLA.X188"] || ""}
                            />
                            <input
                                type="text"
                                className="form-input"
                                placeholder="City"
                                id="field-313"
                                defaultValue={fieldValues["313"] || ""}
                            />
                            <select
                                id="field-321"
                                className="form-input w-full text-sm border rounded p-1"
                                defaultValue={fieldValues["321"] || ""}
                            >
                                <option value="">Select State</option>
                                {US_STATES.map((st) => (
                                    <option key={st.abbrev} value={st.abbrev}>
                                        {st.name}
                                    </option>
                                ))}
                            </select>

                            <input
                                type="text"
                                className="form-input"
                                placeholder="ZIP"
                                id="field-323"
                                defaultValue={fieldValues["323"] || ""}
                                onBlur={async () => await handleZipCodeBlur("field-323", "field-313", "field-321")}
                            />
                        </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                        <div>
                            <label className="form-label">Loan Originator Name</label>
                            <input
                                type="text"
                                className="form-input"
                                id="field-1612"
                                defaultValue={fieldValues["1612"] || ""}
                            />
                        </div>
                        <div>
                            <label className="form-label">Phone Number</label>
                            <input
                                type="text"
                                className="form-input"
                                id="field-1823"
                                defaultValue={fieldValues["1823"] || ""}
                            />
                        </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                        <div>
                            <label className="form-label">Loan Originator NMLSR ID#</label>
                            <input
                                type="text"
                                className="form-input"
                                id="field-3238"
                                defaultValue={fieldValues["3238"] || ""}
                            />
                        </div>
                        <div>
                            {textDateField("Loan Originator Signature Date", "3261")}
                        </div>
                    </div>

                    {/* Financial Institution Section */}
                    <div className="mt-6 border-t border-[var(--blue-2)] pt-4">
                        <h4 className="subsection-title2 mb-2">
                            To Be Completed by Financial Institution (for application taken in person):
                        </h4>
                        <div className="space-y-2">
                            {[
                                { id: "4121", label: "Was the ethnicity of the Borrower collected on the basis of visual observation or surname?" },
                                { id: "4122", label: "Was the sex of the Borrower collected on the basis of visual observation or surname?" },
                                { id: "4123", label: "Was the race of the Borrower collected on the basis of visual observation or surname?" },
                            ].map(({ id, label }) => (
                                <div key={id} className="flex items-center justify-between text-sm text-[var(--slate-grey-2)]">
                                    <label className="flex-1 pr-2">{label}</label>
                                    <div className="flex items-center gap-4">
                                        <label key="Y" className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                className="checkbox-accent"
                                                name={`field-${id}-yes`}
                                                id={`field-${id}-yes`}
                                                checked={state[id] === "Y"}
                                                onChange={() => handleCheckboxChange(id, "Y")}
                                            />
                                            Yes
                                        </label>

                                        <label key="N" className="checkbox-label">
                                            <input
                                                type="checkbox"
                                                className="checkbox-accent"
                                                name={`field-${id}-no`}
                                                id={`field-${id}-no`}
                                                checked={state[id] === "N"}
                                                onChange={() => handleCheckboxChange(id, "N")}
                                            />
                                            No
                                        </label>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Demographic Info Section */}
                    <div className="mt-6 border-t border-[var(--blue-2)] pt-4">
                        <h4 className="subsection-title2 mb-2">
                            The Demographic Information was provided through:
                        </h4>
                        <div className="grid md:grid-cols-2 gap-2 text-sm text-[var(--slate-grey-2)]">
                            {Object.keys(interviewMethodMapping).map((method) => {
                                const allowedValue = interviewMethodMapping[method];
                                return (
                                    <label key={method} className="checkbox-label">
                                        <input
                                            type="checkbox"
                                            className="checkbox-accent"
                                            name="field-4143"
                                            id="field-4143"
                                            value={allowedValue}
                                            checked={state["4143"] === allowedValue}
                                            onChange={() => handleCheckboxChange("4143", allowedValue)}
                                        />
                                        {method}
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoanOriginatorInformation;